import { render, staticRenderFns } from "./OnboardingScreenPanel.vue?vue&type=template&id=dfb1bc42&scoped=true&"
import script from "./OnboardingScreenPanel.vue?vue&type=script&lang=js&"
export * from "./OnboardingScreenPanel.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingScreenPanel.vue?vue&type=style&index=0&id=dfb1bc42&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfb1bc42",
  null
  
)

export default component.exports